module.exports = __webpack_public_path__ + "static/shelby-bio-pic-a5552a04f527b86fc0c923bd453b21d4.jpg";